import { SingleMentorRequestStatus } from "../../redux/schemas/models/mentor-request";

/* @ngInject */
export default function InvitationsAndRequestsManager(

  _,
  $q,
  humps,

  $timeout,

  OfflineManager,
  PusherManager,
  PusherChannels,

  CurrentUserManager,
  CurrentCourseManager,
  InvitationAndRequestModel,
  $state,
) {
  let pusherChannel; let pusherCallback; let
    acceptedCallbacks = [];

  const manager = {
    initialize,
    setCourse,

    requestInvitationsAndRequests,

    getInvitationsAndRequestsReceived,
    getTeamSpecificInvitations,
    getTeamSpecificMembershipRequestsMadeByUser,
    getGroupSpecificInvitations,
    getGroupSpecificMembershipRequestsMadeByUser,
    dataForCourseLoaded,

    setAcceptedCallback,
    acceptInvitationAndRequest,
    rejectInvitationAndRequest,
    cancelRequest,
    addRequest,
    removeRequest,

    // exposed data attributes
    numItems: 0,
    currentCourse: null,
    courses: [],
    coursesHash: {}, // stored based on course id
    mentoringPrograms: [],
    mentoringProgramsHash: {}, // stored based on mentorship program id
    isLoading: false,
    shouldReloadList: true,
    mentorshipProgramEvents: [
      'connection_request_approved',
      'connection_request_rejected',
      'connection_request_created',
      'connection_request_withdrawn',
      'connection_request_deleted',
      'connection_request_dropped',
    ],
  };

  $timeout(() => {
    manager.initialize();
  });

  function initialize() {
    if (CurrentUserManager.hasLoggedIn()) {
    //  requestInvitationsAndRequests();
      CurrentUserManager.requestUserConfigPromise?.then(() => {
        setupPusherEvents();
      });
    }

    OfflineManager.registerReturnOnlineCallback(() => {
      if (CurrentUserManager.hasLoggedIn()) {
        requestInvitationsAndRequests(true);
      }
    });
  }

  function setCourse(course, fromPanel = false) {
    const isMentoringProgram = course?.mentorshipProgram;

    if (course && !isMentoringProgram) {
      manager.currentCourse = manager.coursesHash[course.id];
      manager.currentMentoringProgram = null;
      removeApprovedInvitesAndRequests();
      return $q.when(manager.currentCourse?.requests);
    }

    const mentoringProgramId = course?.mentorshipProgram?.id || $state.params.programId;
    manager.currentCourse = null;
    if (mentoringProgramId && !fromPanel) {
      manager.currentMentoringProgram = manager.mentoringProgramsHash[Number(mentoringProgramId)];
      removeApprovedInvitesAndRequestsFromMentoringProgram();
      return $q.when(manager.currentMentoringProgram?.connectionRequests);
    }
    manager.currentMentoringProgram = null;
    if (manager.shouldReloadList) {
      return requestInvitationsAndRequests()
        .then(() => manager.currentCourse?.requests);
    }

    return null;
  }

  function requestInvitationsAndRequests(hideLoading) {
    if (!hideLoading) {
      manager.isLoading = true;
    }
    manager.shouldReloadList = false;

    manager.invitesAndRequestPromise = InvitationAndRequestModel.getAll(CurrentUserManager.user.id)
      .then(({ courses, mentoringPrograms }) => {
        manager.courses = courses;
        manager.mentoringPrograms = mentoringPrograms;

        _.each(courses, (course) => {
          manager.coursesHash[course.id] = course;
        });

        _.each(mentoringPrograms, (mentoringProgram) => {
          manager.mentoringProgramsHash[mentoringProgram.mentorshipProgram.id] = mentoringProgram;
        });

        setInvitationsAndRequestsItemNumbers(true);

        if (manager.currentCourse) {
          manager.currentCourse = manager.coursesHash[manager.currentCourse.id];
        } else if (CurrentCourseManager.course) {
          manager.currentCourse = manager.coursesHash[CurrentCourseManager.course.id];
        }

        const mentoringProgramId = $state.params.programId;
        if (manager.currentMentoringProgram) {
          manager.currentMentoringProgram = manager.mentoringProgramsHash[manager.currentMentoringProgram.mentorshipProgram.id];
        } else if (mentoringProgramId) {
          manager.currentMentoringProgram = manager.mentoringProgramsHash[Number(mentoringProgramId)];
        }

        manager.isLoading = false;

        return {
          courses: manager.courses,
          mentoringPrograms: manager.mentoringPrograms,
        }
      });

    return manager.invitesAndRequestPromise;
  }

  function setAcceptedCallback(callback) {
    acceptedCallbacks.push(callback);

    return () => {
      acceptedCallbacks = _.without(acceptedCallbacks, callback);
    };
  }

  function acceptInvitationAndRequest(invitationAndRequest) {
    const deferred = $q.defer();

    $timeout(() => {
      invitationAndRequest.approved = true;
      manager.currentCourse.numItems -= 1;
      manager.numItems -= 1;

      // for team requests, we want to dump all other team requests since those are now invalid
      if (invitationAndRequest.isTeamSpecificInvitation()) {
        $timeout(() => {
          manager.currentCourse.requests = _.reject(manager.currentCourse.requests, (request) => {
            if (request !== invitationAndRequest) {
              return request.isTeamSpecificInvitation();
            }
            return false;
          });

          setInvitationsAndRequestsItemNumbers();
        });
      }
      return invitationAndRequest.accept().then(() => {
        _.each(acceptedCallbacks, (callback) => callback(invitationAndRequest, invitationAndRequest.isGroup));
        deferred.resolve(invitationAndRequest);
      });
    });

    return deferred.promise;
  }

  function rejectInvitationAndRequest(invitationAndRequest) {
    const index = _.indexOf(manager.currentCourse.requests, invitationAndRequest);
    // have to remove in next cycle because there are events still listen to the dom in this cycle
    $timeout(() => {
      manager.currentCourse.requests.splice(index, 1);
      manager.currentCourse.numItems -= 1;
      manager.numItems -= 1;
    });

    invitationAndRequest.reject()
      .then(
        (response) => {},
        (error) => {
          $timeout(() => {
            manager.currentCourse.requests.splice(index, 0, invitationAndRequest);
          });
        },
      );
  }

  function cancelRequest(request) {
    const index = _.indexOf(manager.currentCourse.requests, request);

    $timeout(() => {
      manager.currentCourse.requests.splice(index, 1);
    });

    request.cancel()
      .then(
        (response) => {},
        (error) => {
          $timeout(() => {
            manager.currentCourse.requests.splice(index, 0, request);
          });
        },
      );
  }

  // used for interactive behavior on site
  function addRequest(membershipRequest, team) {
    const invitationAndRequest = new InvitationAndRequestModel(_.extend(_.pick(membershipRequest, ['createdAt', 'id', 'message']), {
      className: 'MembershipRequest',
      courseId: CurrentCourseManager.course.id,
      catalogId: CurrentCourseManager.course.catalogId,
      isGroup: team.teamSet.isGroup,
      team: _.pick(team, ['description', 'id', 'name', 'profilePicture']),
      user: _.pick(CurrentUserManager.user, ['firstName', 'id', 'lastName', 'profilePicture']),
    }));

    const currentCourse = manager.coursesHash[CurrentCourseManager.course.id];
    if (currentCourse) {
      currentCourse?.requests.push(invitationAndRequest);
    }
  }

  function removeRequest(request) {
    _.each(manager.courses, (course) => {
      const index = _.findWhere(course.requests, { id: request.id });

      $timeout(() => {
        if (manager.currentCourse) {
          manager.currentCourse.requests.splice(index, 1);
        }
      });
    });
  }


  function getInvitationsAndRequestsReceived(course) {
    const isLoaded = manager.dataForCourseLoaded(course);
    if (isLoaded) {
      const isMentoringProgram = course?.mentorshipProgram;
      if (!!isMentoringProgram) {
        return manager.mentoringProgramsHash[course.mentorshipProgram.id].connectionRequests;
      }
      return _.reject(manager.coursesHash[course.id].requests, (request) => request.isMembershipRequestMadeByUser(CurrentUserManager.user.id));
    }
    return [];
  }

  function getTeamSpecificInvitations(course) {
    if (manager.dataForCourseLoaded(course)) {
      return _.reject(manager.coursesHash[course.id].requests, (request) => !request.isTeamSpecificInvitation(CurrentUserManager.user.id));
    }
    return [];
  }

  function getTeamSpecificMembershipRequestsMadeByUser(course) {
    if (manager.dataForCourseLoaded(course)) {
      return _.reject(manager.coursesHash[course.id].requests, (request) => !request.isTeamSpecificMembershipRequestMadeByUser(CurrentUserManager.user.id));
    }
    return [];
  }

  function getGroupSpecificInvitations(course) {
    if (manager.dataForCourseLoaded(course)) {
      return _.reject(manager.coursesHash[course.id].requests, (request) => !request.isGroupSpecificInvitation(CurrentUserManager.user.id));
    }
    return [];
  }

  function getGroupSpecificMembershipRequestsMadeByUser(course) {
    if (manager.dataForCourseLoaded(course)) {
      return _.reject(manager.coursesHash[course.id].requests, (request) => !request.isGroupSpecificMembershipRequestMadeByUser(CurrentUserManager.user.id));
    }
    return [];
  }

  function dataForCourseLoaded(course) {
    return (
      !!manager.coursesHash[course.id] && !!manager.coursesHash[course.id].requests.length
    ) || (
      !!manager.mentoringProgramsHash[course.mentorshipProgram?.id] && !!manager.mentoringProgramsHash[course.mentorshipProgram?.id].connectionRequests.length
    )
  }

  /** Private Functions * */
  function setupPusherEvents() {
    pusherChannel = PusherManager.setupChannel(PusherChannels.userChannel(CurrentUserManager.user.anonymizedIdentifier.substr(0, 10)));
    pusherChannel.bind('new_team_request_or_invitation', (pusherData) => {
      pusherData = humps.camelizeKeys(pusherData);

      const course = manager.coursesHash[pusherData.courseId];

      $timeout(() => {
        if (course) {
          manager.numItems += 1;
          if (course.numNewItems) {
            course.numNewItems += 1;
          } else {
            course.numNewItems = 1;
          }

          if (course.numItems) {
            course.numItems += 1;
          } else {
            course.numItems = 1;
          }
        }
        if (manager.currentCourse) {
          manager.shouldReloadList = true;
        } else {
          requestInvitationsAndRequests();
        }
      });
    });

    pusherChannel.bind('team_invitation_take_back', (pusherData) => {
      pusherData = humps.camelizeKeys(pusherData);

      const course = manager.coursesHash[pusherData.courseId];

      $timeout(() => {
        if (course) {
          manager.numItems -= 1;
          if (course.numNewItems) {
            course.numNewItems -= 1;
          }

          if (course.numItems) {
            course.numItems -= 1;
          }
        }
        if (manager.currentCourse) {
          manager.shouldReloadList = true;
        } else {
          requestInvitationsAndRequests();
        }
      });
    });

    manager.mentorshipProgramEvents?.forEach((event) => {
      pusherChannel.bind(event, requestInvitationsAndRequests);
    });
  }

  function unsubscribePusherEvents() {
    pusherChannel.unbind('new_team_request_or_invitation', pusherCallback);
    pusherChannel.unbind('team_invitation_take_back', pusherCallback);
  }

  function setInvitationsAndRequestsItemNumbers(ignoreApproved) {
    const programsAndCourses = [...manager.courses, ...manager.mentoringPrograms];
    manager.numItems = 0;
    _.each(programsAndCourses, (course) => {
      if (ignoreApproved) {
        course.numItems = manager.getInvitationsAndRequestsReceived(course).length;
      } else {
        course.numItems = _.reduce(manager.getInvitationsAndRequestsReceived(course), (memo, request) => {
          if (!request.approved) {
            return memo + 1;
          }
          return memo;
        }, 0);
      }
      manager.numItems += course.numItems;
    });
  }

  function removeApprovedInvitesAndRequests() {
    if (manager.currentCourse) {
      manager.currentCourse.requests = _.reject(manager.currentCourse.requests, (request) => request.approved || request.error);
    }
  }

  function removeApprovedInvitesAndRequestsFromMentoringProgram() {
    if (manager.currentMentoringProgram) {
      manager.currentMentoringProgram.connectionRequests = _.reject(manager.currentMentoringProgram.connectionRequests, (request) => (
        [
          SingleMentorRequestStatus.APPROVED,
          SingleMentorRequestStatus.REJECTED,
          SingleMentorRequestStatus.DROPPED,
          SingleMentorRequestStatus.WITHDRAW,
        ].includes(request.status)
      ));
    }
  }

  return manager;
}
